"use client";

export default function TravelHero() {
  const headlineWords = [{
    text: "Your",
    italic: false
  }, {
    text: "next",
    italic: false
  }, {
    text: "adventure",
    italic: false
  }, {
    text: "awaits.",
    italic: true
  }];
  return <section data-section-id="2777" id="travelspecialshero" className="bg-background text-foreground relative min-h-[85vh] w-full overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        {}
        <div className="mb-12 md:mb-20">
          <span className="font-default text-xs md:text-sm uppercase tracking-[0.18em]" style={{
          color: "var(--chart-5)"
        }}>&nbsp;MARGA TRAVEL — EXCLUSIVE HOLIDAY PACKAGES</span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          {}

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 className="font-default font-bold leading-[0.92] tracking-tight text-primary">
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.18em]" style={{
              paddingBottom: "0.08em"
            }}>
                  <span className="inline-block !text-7xl !italic" style={{
                color: word.italic ? "var(--secondary)" : "inherit"
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>

            <p className="font-default mt-10 md:mt-14 max-w-[36ch] text-base md:text-lg leading-relaxed" style={{
            color: "var(--muted-foreground)"
          }}>
              Discover curated travel experiences designed to inspire, relax, and create memories that last a lifetime.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center gap-8 lg:gap-10 lg:pl-6">
            {}
            <figure className="">
              <div className="overflow-hidden rounded-lg bg-card shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/tropical_beach_resort.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/tropical_beach_resort.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/tropical_beach_resort.png-wvc-sizes" alt="Luxury tropical beach resort with turquoise waters" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                featured / island escapes
              </figcaption>
            </figure>

            {}
            <figure className="ml-auto w-[72%]">
              <div className="overflow-hidden rounded-lg bg-card shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/mountain_adventure_view.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/mountain_adventure_view.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/mountain_adventure_view.png-wvc-sizes" alt="Breathtaking mountain range view for adventure seekers" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-square" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                featured / mountain peaks
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}